<template>
  <section class="localizedInfoSection">
    <template v-for="(sectionItem, i) of tm(sectionName)">
      <h1 :key="i" v-if="sectionItem.heading1">{{ rt(sectionItem.heading1) }}</h1>
      <h2 :key="i" v-if="sectionItem.heading2">{{ rt(sectionItem.heading2) }}</h2>
      <h3 :key="i" v-if="sectionItem.heading3">{{ rt(sectionItem.heading3) }}</h3>
      <p :key="i" v-if="sectionItem.p" v-html="i18nWithLink(rt(sectionItem.p), sectionItem.link? rt(sectionItem.link):'')"></p>
      <img :key="i" v-if="sectionItem.img" :src="assetUrl(sectionItem.img)" :alt="rt(sectionItem.alt)" :title="rt(sectionItem.alt)"/>
    </template>

    <slot></slot>

  </section>
</template>

<script src="./localizedInfoSection.ts"/>

<style src="./localizedInfoSection.css"/>
